module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errors"
  }, [_c('div', {
    staticClass: "errors__warning"
  }, [(_vm.firstErrorInErrors) ? _c('p', {
    staticClass: "errors__paragraph"
  }, [_vm._v(_vm._s(_vm.firstErrorInErrors))]) : _c('ol', {
    staticClass: "errors__list"
  }, _vm._l((_vm.errors), function(item, key) {
    return _c('li', {
      key: key,
      staticClass: "errors__item",
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5f824e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/errors/Errors.vue
// module id = 894b071d17b7a65cbb12
// module chunks = 89